import { PessoaService } from '../../pessoa.service';
import { Clube } from './../clube';
import { Component, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { SwalComponent } from '@toverux/ngx-sweetalert2';
import { SYSCONF_SIGLA } from 'src/app.api';
@Component({
	selector: 'app-clube-detail',
  	templateUrl: './clubeDetail.component.html',
  	styleUrls: ['./clubeDetail.component.scss']
})

export class ClubeDetailComponent implements OnInit{
	@ViewChild('Swal') public swal:SwalComponent; 
	public message:string = '';
	detailForm: FormGroup;
	clube: Clube;
	clube_id:number;
	thumb:string = '';
	pessoa_id:number;
	enderecos:object = new Array();
	telefones:object = new Array();
	contasBancarias:object = new Array();
	sigla = SYSCONF_SIGLA;
	anexos: any;
	acesso = new Array();
	constructor(private pessoaService: PessoaService, private activatedRoute: ActivatedRoute,private formBuilder: FormBuilder){
		this.detailForm = this.formBuilder.group({
			id: this.formBuilder.control(0),
			dt_cadastro: this.formBuilder.control(''),
			dt_atualizacao: this.formBuilder.control(''),
			cnpj: this.formBuilder.control(''),
			razao_social: this.formBuilder.control(''),
			nome_completo: this.formBuilder.control(''),
			email: this.formBuilder.control(''),
			status: this.formBuilder.control(''),
			federacao_id: this.formBuilder.control(''),
			sigla: this.formBuilder.control(''),
			federado: this.formBuilder.control(''),
			observacao: this.formBuilder.control(''),
			foto: this.formBuilder.control(''),
			website: this.formBuilder.control(''),
		});	
		this.clube_id = this.activatedRoute.snapshot.params['id'];
		this.pessoaService.getPessoaById('pessoa/clube',this.clube_id).subscribe(
		(clube) => {
			this.clube = clube.dados;
			this.pessoa_id = this.clube.pessoa_id;
			this.acesso = this.clube.acesso;
			if(this.clube.foto){
				this.thumb = this.clube.foto.thumb;
			}
			this.pessoaService.getPessoaById('pessoa',this.pessoa_id).subscribe(
				(success) =>{
					this.enderecos = success.dados.endereco;
					this.telefones = success.dados.telefone;
					this.contasBancarias = success.dados.conta_bancaria;
					this.anexos = success.dados.anexo;
				},
				(error) => {
					this.message = error.error.message;
				})
				this.detailForm.patchValue({
					id: this.clube.id,
					dt_cadastro: this.clube.dt_cadastro_br,
					dt_atualizacao: this.clube.dt_atualizacao_br,
					cnpj: this.clube.cnpj,
					razao_social: this.clube.razao_social,
					nome_completo: this.clube.nome_completo,
					email: this.clube.email,
					status: this.clube.status,
					federacao_id: this.clube.federacao_id,
					sigla: this.clube.sigla,
					federado: this.clube.federado == 'S' ? 'S' : 'N',
					observacao: this.clube.observacao,
					foto: this.thumb,
					website: this.clube.website,
				});
			})
		}

	ngOnInit(){
		let t = JSON.parse(localStorage.getItem('CONFLogin'));
		if(!t.permissao.pessoa_clube.includes("CONSULTAR"))
			this.message = 'Você não possui permissão para executar esta ação'
	}
	
	
}